// extracted by mini-css-extract-plugin
export default {"wrapper":"LastOrders_wrapper__Vhi2G","container":"LastOrders_container__bVwyU"};